export default "assets/menu-arrow-f4960344.svg";